var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.title))]),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"to":_vm.linkPath,"color":"primary"}},[_vm._v(" Go ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }